import { Lock, Instagram } from "lucide-react";
import { IG_PROFILE } from "../lib/api";

export function LicenseExpired() {
  return (
    <div data-testid="license-expired-screen" className="mx-auto max-w-lg rounded-3xl border border-slate-200 bg-white p-8 text-center shadow-sm">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-rose-100 text-rose-600">
        <Lock className="h-7 w-7" />
      </div>
      <h1 className="mt-4 font-heading text-2xl font-bold text-slate-900">Lisans süreniz sona erdi</h1>
      <p className="mt-2 text-sm text-slate-600">
        Verileriniz güvende. Kullanmaya devam etmek için Instagram'da <b>@kasamnetcom</b> hesabına mesaj atarak lisansınızı yenileyin.
      </p>
      <a href={IG_PROFILE} target="_blank" rel="noreferrer" data-testid="expired-instagram-link"
        className="mt-6 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-pink-500 via-fuchsia-500 to-orange-400 px-6 py-3 font-semibold text-white shadow">
        <Instagram className="h-5 w-5" /> Lisansımı Yenile
      </a>
    </div>
  );
}
